import { call, put, takeLatest, all } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import * as types from './actionTypes';
import { post } from "../../../../helpers/api_helper";
import { fetchDeductionFailure, fetchDeductionSuccess, fetchFixedDeductionSuccess, fetchFixedDeductionFailure } from './actions';

// Fetch Fixed Deduction
function* fetchFixedDeductionSaga(action) {  
  try {    
    const response = yield call(post, process.env.REACT_APP_PAYROLL_DEDUCTION_FETCH_FIXED_DEDUCTION,action.payload); // Replace with actual endpoint
    yield put(fetchFixedDeductionSuccess(response));
  } catch (error) {
    console.error("Saga API Error:", error);
    yield put(fetchFixedDeductionFailure(error.message));
  }
}

// Fetch Deduction
function* fetchDeductionSaga(action) {
  const {unit_id,type_id} = action.payload;
  try {
    const formData = new FormData();
    formData.append("unit_id", unit_id);
    formData.append("type_id", type_id);
    const response = yield call(post, process.env.REACT_APP_PAYROLL_DEDUCTION_FETCH_DROPDOWN_DEDUCTION,formData); // Replace with actual endpoint
    // if (!response || response.status !== 'success') {
    //   throw new Error(response?.message || 'Failed to fetch FixedDeduction!');
    // }
    yield put(fetchDeductionSuccess(response));
  } catch (error) {
    console.error("Saga API Error:", error);
    yield put(fetchDeductionFailure(error.message));
  }
}

// 💾 Save Saga
function* saveFixedDeductionSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_PAYROLL_DEDUCTION_SAVE_FIXED_DEDUCTION, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to save FixedDeduction!');
    }

    yield put({ type: types.PAYROLL_DEDUCTION_SAVE_FIXED_DEDUCTION_SUCCESS, payload: response });
    Swal.fire('Success', 'Saved successfully!', 'success');
  } catch (error) {
    Swal.fire({
      title: 'Error',
      text: error.message || 'Something went wrong while saving!',
      icon: 'error',
      confirmButtonText: 'OK',
    });

    yield put({ type: types.PAYROLL_DEDUCTION_SAVE_FIXED_DEDUCTION_FAILURE, payload: error });
  }
}

// Remove Saga
function* removeFixedDeductionSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_PAYROLL_DEDUCTION_REMOVE_FIXED_DEDUCTION, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to save FixedDeduction!');
    }

    yield put({ type: types.PAYROLL_DEDUCTION_REMOVE_FIXED_DEDUCTION_SUCCESS, payload: response });
    Swal.fire('Success', 'Deleted successfully!', 'success');
  } catch (error) {
    Swal.fire({
      title: 'Error',
      text: error.message || 'Something went wrong while saving!',
      icon: 'error',
      confirmButtonText: 'OK',
    });

    yield put({ type: types.PAYROLL_DEDUCTION_REMOVE_FIXED_DEDUCTION_FAILURE, payload: error });
  }
}

// 🔄 Change Status Saga
function* changeFixedDeductionStatusSaga(action) {
  try {

    const response = yield call(post, process.env.REACT_APP_PAYROLL_DEDUCTION_CHANGE_FIXED_DEDUCTION_STATUS, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to change status!');
    }

    yield put({ type: types.PAYROLL_DEDUCTION_CHANGE_FIXED_DEDUCTION_STATUS_SUCCESS, payload: response });
    Swal.fire('Success', 'Status updated!', 'success');
  } catch (error) {
    Swal.fire({
      title: 'Error',
      text: error.message || 'Something went wrong while updating status!',
      icon: 'error',
      confirmButtonText: 'OK',
    });

    yield put({ type: types.PAYROLL_DEDUCTION_CHANGE_FIXED_DEDUCTION_STATUS_FAILURE, payload: error });
  }
}

function* deductionGetTemplateSaga(action) {
  try {
     const response = yield call(post, process.env.REACT_APP_FETCH_FIXED_DEDUCTION_GETTEMPLATE, action.payload);

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to download template!");
    }

    // ✅ Trigger file download
    if (response?.data) {
      const fileUrl = `${process.env.REACT_APP_IMAGE_BASE_URL}${response.data}`; // full URL
      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = "EmployeePunchTemplate.xlsx"; // optional filename
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    Swal.fire("Success", "Template downloaded successfully!", "success");
    yield put({ type: types.PAYROLL_DEDUCTION_FIXED_TEMPLATE_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire("Error", error.message, "error");
    yield put({ type: types.PAYROLL_DEDUCTION_FIXED_TEMPLATE_FAILURE, payload: error });
  }
}

function* deductionimportSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_FIXED_DEDUCTION_TEMPLATEIMPORT, action.payload);

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to import Punchlist!");
    }
    Swal.fire('Success', response?.message, response?.status);
    yield put({ type: types.PAYROLL_DEDUCTION_FIXED_IMPORT_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire("Error", error.message, "error");
    yield put({ type: types.PAYROLL_DEDUCTION_FIXED_IMPORT_FAILURE, payload: error });
  }
}

// 🔄 Root Saga
export default function* fixedDeductionSaga() {
  yield all([
    takeLatest(types.PAYROLL_DEDUCTION_FETCH_FIXED_DEDUCTION, fetchFixedDeductionSaga),
    takeLatest(types.PAYROLL_DEDUCTION_SAVE_FIXED_DEDUCTION, saveFixedDeductionSaga),
    takeLatest(types.PAYROLL_DEDUCTION_REMOVE_FIXED_DEDUCTION, removeFixedDeductionSaga),
    takeLatest(types.PAYROLL_DEDUCTION_CHANGE_FIXED_DEDUCTION_STATUS, changeFixedDeductionStatusSaga),
    takeLatest(types.PAYROLL_DEDUCTION_FETCH_DROPDOWN_DEDUCTION, fetchDeductionSaga),
    takeLatest(types.PAYROLL_DEDUCTION_FIXED_TEMPLATE, deductionGetTemplateSaga),
    takeLatest(types.PAYROLL_DEDUCTION_FIXED_IMPORT, deductionimportSaga),
  ]);
}
